import { WikiInspectionType } from '../../api/jurisdiction';
import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    saveJurisdiction: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdictions/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiJurisdiction'],
    }),
    updateJurisdiction: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdictions/${arg.id}/`,
          method: 'PATCH',
          body: arg,
        };
      },
      invalidatesTags: ['wikiJurisdiction'],
    }),
    getAllJurisdictions: builder.query<any, any>({
      query: params => ({
        url: '/wiki/wiki-jurisdictions/',
        params,
      }),
      providesTags: ['wikiJurisdiction'],
    }),
    getJurisdictionsByState: builder.query<any, string>({
      query: params => ({
        url: `wiki/jurisdictions-by-state/?state=${params}`,
      }),
      providesTags: ['wikiJurisdiction'],
      keepUnusedDataFor: 360000000,
    }),
    addWikiContact: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-contacts/`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    updateWikiContact: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-contacts/${arg.id}/`,
          method: 'PATCH',
          body: arg,
        };
      },
    }),
    addWikiLink: builder.mutation({
      query: arg => {
        return {
          url: `wiki/links/`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    updateWikiLink: builder.mutation({
      query: arg => {
        return {
          url: `wiki/links/${arg.id}/`,
          method: 'PATCH',
          body: arg,
        };
      },
    }),
    deleteWikiContact: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-contacts/${arg.id}/`,
          method: 'DELETE',
        };
      },
    }),
    deleteWikiLink: builder.mutation({
      query: arg => {
        return {
          url: `wiki/links/${arg.id}/`,
          method: 'DELETE',
        };
      },
    }),
    getPermittingPassword: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction/${arg.id}/retrieve_password/`,
          method: 'GET',
        };
      },
    }),
    getJurisdictionById: builder.query({
      query: arg => {
        return {
          url: `wiki/jurisdictions-by-id/?id=${arg.id}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0,
    }),
    checkJurisdictionDuplicate: builder.query<
      { duplicate: boolean; jurisdiction?: { id: number; jurisdictions: string; address: string; city: string; state: string } },
      string
    >({
      query: address => ({
        url: `wiki/jurisdictions-duplicate-check/`,
        params: { address },
      }),
      providesTags: ['wikiJurisdiction'],
      keepUnusedDataFor: 0,
    }),
    getJurisdictionAuditLog: builder.query<JurisdictionAuditEntry[], number>({
      query: id => ({
        url: `wiki/jurisdictions-audit-log/`,
        params: { id },
      }),
      providesTags: ['wikiJurisdiction'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export type JurisdictionAuditEntry = {
  id: number;
  action: 'create' | 'update' | 'delete';
  timestamp: string;
  actor: { id: number; name: string; email: string } | null;
  changes: { field: string; label: string; old: string | null; new: string | null }[];
};

export const {
  useSaveJurisdictionMutation,
  useUpdateJurisdictionMutation,
  useGetAllJurisdictionsQuery,
  useGetJurisdictionsByStateQuery,
  useAddWikiContactMutation,
  useUpdateWikiContactMutation,
  useAddWikiLinkMutation,
  useUpdateWikiLinkMutation,
  useDeleteWikiContactMutation,
  useDeleteWikiLinkMutation,
  useGetJurisdictionByIdQuery,
  useCheckJurisdictionDuplicateQuery,
  useLazyCheckJurisdictionDuplicateQuery,
  useGetJurisdictionAuditLogQuery,
} = api;
